const LOGO_URL = `${process.env.PUBLIC_URL}/anchorside-logo.png`;

export const Logo = ({ dark = false, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Anchorside Global"
    data-testid="brand-logo"
    className={`h-14 md:h-16 w-auto object-contain ${className}`}
    style={dark ? { filter: "brightness(0) invert(1)" } : undefined}
  />
);
